export const skillsData = {
  "Backend & APIs": [
    "Node.js",
    "TypeScript",
    "JavaScript",
    "Express",
    "NestJS",
    "REST APIs",
    "GraphQL"
  ],

  "Databases & Caching": [
    "PostgreSQL",
    "MySQL",
    "MongoDB",
    "Redis",
    "Elasticsearch"
  ],

  "System Design & Architecture": [
    "Microservices Architecture",
    "Event-Driven Systems",
    "Scalable API Design",
    "Distributed Systems",
    "Caching Strategies",
    "Database Optimization"
  ],

  "Cloud & DevOps": [
    "AWS (EC2, S3, RDS, CloudWatch)",
    "Docker",
    "Kubernetes",
    "Terraform",
    "GitHub Actions",
    "CI/CD Pipelines"
  ],

  "Message Queues & Streaming": [
    "Kafka",
    "RabbitMQ",
    "Redis Streams",
    "BullMQ",
    "AWS SQS"
  ],

  "Frontend (Supporting)": [
    "React",
    "Next.js",
    "Tailwind CSS"
  ]
};
